import { findPaypalInfo } from "../Util/queries";
import { constructPaypalInfo } from "../Factory/factory";
import { PAYPAL_INFO } from "../Reducers/paypalInfoReducer";

export const getPaypalInfo = () => async (dispatch) => {
    try {
        const response = await findPaypalInfo();

        const paypalInfo = constructPaypalInfo(
            response.data.paypalAccountId,
            response.data.paypalEmail,
            response.data.paypalCustomerId,
            response.data.confirmedAt
        );

        dispatch({
            type: PAYPAL_INFO,
            payload: paypalInfo,
        });
    } catch (e) {
        console.error(e);
        dispatch({
            type: PAYPAL_INFO,
            payload: null,
        });
    }
};
